import React, { useContext } from "react";
import { Page, PageHeader, PageTitle } from "components/ui/Page";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { TwoToOneLayout, PageColumn } from "components/ui/PageColumns";
import WithMyAcademics from "components/data/WithMyAcademics";
import WithSemesters from "components/data/WithSemesters";
import SemestersContext from "components/contexts/SemestersContext";
import { SemesterCoursesCard } from "components/cards/SemesterCoursesCard";
import { Spinner } from "components/ui/Spinner";
import { TeachingCoursesCard } from "../cards/TeachingCoursesCard";
import { FacultyHigherDegreeCommitteesCard } from "../cards/FacultyHigherDegreeCommitteesCard";
import { InstructorFinalExamScheduleCard } from "../cards/InstructorFinalExamScheduleCard";

export function InstructorAcademicsPage() {
  return (
    <Page>
      <PageTitle title="My Academics" />
      <PageHeader>My Academics</PageHeader>
      <LargeSpacer />

      <WithMyAcademics>
        <WithSemesters>
          <InstructorAcademicsPageUI />
        </WithSemesters>
      </WithMyAcademics>
    </Page>
  );
}

const InstructorAcademicsPageUI = () => {
  const { loadState } = useContext(SemestersContext);

  if (loadState && loadState === "success") {
    return (
      <TwoToOneLayout $reverse="true">
        <PageColumn>
          <SemesterCoursesCard displayTitleTerm={true}/>
          <InstructorFinalExamScheduleCard />
        </PageColumn>
        <PageColumn>
          <TeachingCoursesCard />
          <FacultyHigherDegreeCommitteesCard />
        </PageColumn>
      </TwoToOneLayout>
    );
  }

  return <Spinner />;
};
